
/* fix filters in request for selected row */

// import { isRequestForSelectedTranscript } from './utils'

export default {
  middlewareForRequest: ({ loadOptions, totalCount, selectedTranscriptForPreviev, onResolve }) => loadOptions
  /* TODO: переделать чтобы блокировал только запросы на выбраный транскрипт */
  // if (isRequestForSelectedTranscript(loadOptions.filter)) {
  //   onResolve({
  //     data: [selectedTranscriptForPreviev],
  //     totalCount,
  //   });
  // }
  ,
}
